import { CommonModule, Location } from '@angular/common';
import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './admin-user-profile.component.html',
  styleUrls: ['./admin-user-profile.component.scss'],
})
export class AdminUserProfileComponent implements OnInit, OnDestroy, AfterViewInit {
  tabs = [
    { label: 'User Details', path: 'details' },
    { label: 'Billing', path: 'billing' },
    { label: 'Courses', path: 'courses' },
  ];

  currentTab: string = 'details';
  private subscription = new Subscription();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
  ) {}

  ngOnInit(): void {
    this.updateCurrentTab(this.router.url);

    this.subscription.add(
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
        this.updateCurrentTab(this.router.url);
      }),
    );
  }

  underlineStyle = {
    left: '0',
    width: '0',
  };

  moveUnderline(index: number, el: HTMLElement) {
    const rect = el.getBoundingClientRect();
    const parentRect = el.parentElement?.getBoundingClientRect();
    if (rect && parentRect) {
      this.underlineStyle = {
        left: `${rect.left - parentRect.left}px`,
        width: `${rect.width}px`,
      };
    }
  }

  goBack(): void {
    this.router.navigate(['/user-management']);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  activeTabWidth = '0';
  activeTabLeft = '0';

  ngAfterViewInit(): void {
    setTimeout(() => this.updateDividerPosition());
  }

  updateDividerPosition(): void {
    const tabs = document.querySelectorAll('.profile__tab');
    const activeIndex = this.tabs.findIndex((tab) => tab.path === this.currentTab);
    const activeTab = tabs[activeIndex] as HTMLElement;

    if (activeTab) {
      this.activeTabWidth = `${activeTab.offsetWidth}px`;
      this.activeTabLeft = `${activeTab.offsetLeft}px`;
    }
  }

  updateCurrentTab(url: string): void {
    const lastSegment = url.split('/').pop();
    this.currentTab = lastSegment || 'details';
    setTimeout(() => this.updateDividerPosition());
  }
  setActiveTab(tab: string): void {
    this.router.navigate([tab], { relativeTo: this.route });
  }

  isActive(tabPath: string): boolean {
    return this.currentTab === tabPath;
  }
}
